import Vue from 'vue'
import constants from './constants.js'
import fileutil from './fileutil.js'
import { Message } from 'element-ui'

Vue.mixin({
  computed: {
    Constants () {
      return constants
    },
    FileUtil () {
      return fileutil
    }
  },
  methods: {
    successMessage (message, duration) {
      Message({
        type: 'success',
        message: message,
        duration: duration || 3000
      })
    },
    errorMessage (message, duration) {
      Message({
        type: 'error',
        message: message,
        duration: duration || 5000
      })
    },
    equalObject (obj1, obj2) {
      return JSON.stringify(obj1) === JSON.stringify(obj2)
    },
    contentHeight () {
      return window.innerHeight - constants.HEADER_HEIGHT - constants.FOOTER_HEIGHT
    },
    previewHeight () {
      return this.contentHeight() - constants.HEADER_HEIGHT - constants.FOOTER_HEIGHT
    },
    cloneObject (obj) {
      return JSON.parse(JSON.stringify(obj))
    },
    objArraySort (ary, key, order) {
      var reverse = 1
      if (order && order.toLowerCase() === 'desc') reverse = -1
      ary.sort(function (a, b) {
        if (a[key] < b[key]) {
          return -1 * reverse
        } else if (a[key] === b[key]) {
          return 0
        } else {
          return 1 * reverse
        }
      })
      return ary
    },
    formatDate (dateString, format) {
      if (!dateString) return ''
      var date = new Date(dateString)
      if (!format) format = 'YYYY-MM-DD hh:mm:ss.SSS'
      format = format.replace(/YYYY/g, date.getFullYear())
      format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
      format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2))
      format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2))
      format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2))
      format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2))
      if (format.match(/S/g)) {
        var milliSeconds = ('00' + date.getMilliseconds()).slice(-3)
        var length = format.match(/S/g).length
        for (var i = 0; i < length; i++) format = format.replace(/S/, milliSeconds.substring(i, i + 1))
      }
      return format
    }
  }
})



// WEBPACK FOOTER //
// ./src/mixin/global/index.js